import { render } from "./MyTendinousView.vue?vue&type=template&id=10503529"
import script from "./MyTendinousView.vue?vue&type=script&lang=js"
export * from "./MyTendinousView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__